import { isProductionEnv } from "./VersionUtil";

/** console.log wrapper — only logs in dev / Version environments. */
export const devLog = (...args: unknown[]) => {
    if (!isProductionEnv()) {
        console.log(...args);
    }
}
